"use client"
import { PropsWithChildren, useEffect } from "react"
import { default as posthog } from "posthog-js"
import { PostHogProvider as PostHogProviderLib } from "posthog-js/react"

export function PostHogProvider(props: PropsWithChildren) {
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      (process.env.NODE_ENV !== "development" ||
        process.env.ENABLE_TELEMETRY === "1")
    ) {
      if (typeof window !== "undefined") {
        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
          api_host: `${window.location.origin}/ingest`,
          ui_host: "https://us.posthog.com",
          person_profiles: "always",
          capture_pageview: false, // Disable automatic pageview capture, as we capture manually
          capture_pageleave: true,
          loaded: (posthog) => {
            if (process.env.NODE_ENV === "development") posthog.debug()
          },
        })
      }
    }
  }, [])
  return (
    <PostHogProviderLib client={posthog}>{props.children}</PostHogProviderLib>
  )
}
